import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogDisableSlotView.propTypes = {
  slotRow: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogDisableSlotView({ slotRow = {}, onCancel, onDone }) {
  const [loading, setLoading] = useState(false);

  const slotCode =
    slotRow?.slotCode ??
    (slotRow?.slotNumber != null ? `Ngăn số ${slotRow.slotNumber}` : slotRow?.slotId ?? '');
  const iconSrc = AppResource.vng?.vngDisabled;

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // TODO: gọi API vô hiệu hóa ngăn pin khi có API
      ToastHelper.showSuccess('Vô hiệu hóa ngăn pin thành công');
      if (onDone) onDone();
    } catch (error) {
      ToastHelper.showError(error?.message || 'Vô hiệu hóa ngăn pin thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-3">
        <div className="">{iconSrc && <img src={iconSrc} alt="" />}</div>
        <span style={UIHelper.buildFontStyle('600', '16px', undefined, AppColors.gray[800])}>
          Vô hiệu hóa
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', undefined, AppColors.gray[600])}>
          Bạn có chắc muốn vô hiệu hóa ngăn pin <strong>{slotCode}</strong>? Trong quá trình vô
          hiệu hóa, hệ thống sẽ ngắt dòng sạc, khóa cửa ngăn pin,... và không cho phép diễn ra các
          giao dịch đổi pin.
        </span>
      </div>

      <div
        className="d-flex align-items-center gap-3 p-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        <div className="w-50">
          {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        </div>
        <div className="w-50">
          {UIHelper.buildRedButton('Vô hiệu hóa', handleSubmit, null, false, loading)}
        </div>
      </div>
    </div>
  );
}

export default DialogDisableSlotView;
